/**
 * Constantes y valores predeterminados para WhatsApp Business API
 */

export const PLANTILLAS_PREDETERMINADAS = [
  {
    id: 'confirmacion_pago',
    titulo: 'Confirmación de Pago',
    nombre_meta: 'confirmacion_pago',
    icono: 'mdi mdi-receipt',
    categoria: 'UTILITY',
    idioma: 'es_MX',
    idioma_registrado_meta: null,
    estado_meta: 'NO_REGISTRADA',
    id_meta: null,
    tipo_encabezado: 'IMAGE',
    encabezado: '',
    url_imagen_encabezado: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600&auto=format&fit=crop&q=80',
    cuerpo: 'Estimado/a {{nombre_completo}}, confirmamos que hemos recibido su pago por la cantidad de {{monto}} correspondiente a su servicio. Su cuenta se encuentra al corriente. ¡Muchas gracias por su preferencia!',
    pie: 'Comprobante emitido por el sistema'
  },
  {
    id: 'inicio_conversacion',
    titulo: 'Inicio de Conversación',
    nombre_meta: 'inicio_conversacion',
    icono: 'mdi mdi-message-text-outline',
    categoria: 'UTILITY',
    idioma: 'es_MX',
    idioma_registrado_meta: null,
    estado_meta: 'NO_REGISTRADA',
    id_meta: null,
    tipo_encabezado: 'NONE',
    encabezado: '',
    url_imagen_encabezado: '',
    cuerpo: 'Hola {{nombre_completo}}, nos comunicamos de {{nombre_empresa}} para dar seguimiento a su cuenta y brindarle asistencia. ¿En qué podemos ayudarle el día de hoy?',
    pie: ''
  }
]

export const GRUPOS_VARIABLES = [
  {
    categoria: 'Datos de la empresa',
    icono: 'mdi mdi-domain',
    btnClass: 'btn-outline-info',
    variables: [
      { codigo: '{{nombre_empresa}}', descripcion: 'Nombre de la empresa' }
    ]
  },
  {
    categoria: 'Datos del cliente',
    icono: 'mdi mdi-account-circle-outline',
    btnClass: 'btn-outline-primary',
    variables: [
      { codigo: '{{nombre_completo}}', descripcion: 'Nombre completo' },
      { codigo: '{{nombre}}', descripcion: 'Nombre' },
      { codigo: '{{apellido_paterno}}', descripcion: 'Apellido paterno' },
      { codigo: '{{apellido_materno}}', descripcion: 'Apellido materno' },
      { codigo: '{{rfc}}', descripcion: 'RFC' },
      { codigo: '{{correo_electronico}}', descripcion: 'Correo electrónico' },
      { codigo: '{{calle}}', descripcion: 'Calle' },
      { codigo: '{{colonia}}', descripcion: 'Colonia' },
      { codigo: '{{codigo_postal}}', descripcion: 'Código postal' }
    ]
  }
]

export function etiquetaEstadoMeta(status) {
  if (!status) return 'No consultado'
  switch (status.toUpperCase()) {
    case 'APPROVED': return 'Aprobada'
    case 'PENDING': return 'En Revisión'
    case 'REJECTED': return 'Rechazada'
    case 'PAUSED': return 'Pausada'
    case 'DISABLED': return 'Deshabilitada'
    case 'NO_REGISTRADA': return 'No Registrada'
    default: return status
  }
}

